export const FUND_TAGS_STORE = 'fundTags';
